import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { SDK_EVENTS, EVENTS } from '../../../constants/events.cnst';
import { ClassMapConstanst, IdMapConstant, ProjConstants } from '../../../constants/projConsts';
import { getHTML } from '../../base/domManager';
import { ArticleSuggestion } from '../suggestions/article/article';
import { FAQSuggestion } from '../suggestions/faq/faq';
import { FileSuggestion } from '../suggestions/file/file';
import { SnippetSuggestion } from '../suggestions/snippet/snippet';
import {SuggestionPlaceholder} from '../suggestion-placeholder/suggestion-placeholder';
import './assist-suggestions.scss';
import { HandleViewMoreLessButtons } from '../atom/actionButtons';
import { DialogSuggestion } from '../suggestions/dialog/dialog';
import { FeebackConst } from '../../../constants/settingsConsts';

export function AssistSuggestions(properties: any) {
    
    const props = properties.msgData;
    const [searchResponse, setSearchResponse] = useState(props.suggestions.searchResponse);
    const [responseUUId, setResponseUUId] = useState(props.suggestions.uuid);
    const hostInstance = props.hostInstance;
    const rootServiceInstance = hostInstance.rootService;

    const classConstants : any = ClassMapConstanst;
    const idConstants : any = IdMapConstant;

    useEffect(() => {        
        setSuggestions();
    }, []);

    // useEffect(() => {
    //     if(props.ambiguityToken && Object.keys(props.ambiguityToken)?.length > 0){
    //         let faqId = idConstants.ASSIST_FAQ_SUGGESTION + props.suggestionIndex;
    //         rootServiceInstance.handleFaqAmbiguityDescElement(faqId, props.ambiguityToken, searchResponse?.faqs, hostInstance);
    //     }
    // }, [props.suggestions]);

    const setSuggestions = () => {        
        let faqSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.ASSIST_FAQ_SUGGESTION + props.suggestionIndex}`);
        let snippetSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.ASSIST_SNIPPET_SUGGESTION + props.suggestionIndex}`);
        let articleSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.ASSIST_ARTICLE_SUGGESTION + props.suggestionIndex}`);
        let fileSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.ASSIST_FILE_SUGGESTION + props.suggestionIndex}`);
        let dialogSuggestionElement = hostInstance?.chatEle?.querySelector(`#${idConstants.ASSIST_DIALOG_SUGGESTION + props.suggestionIndex}`);

        if ((searchResponse?.dialogs || [])?.length) {
            let dialogHtml: any;
            dialogHtml = getHTML(DialogSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, suggestions: searchResponse.dialogs, suggestionIndex : props.suggestionIndex, type : 'assist'}, hostInstance);
            rootServiceInstance.checkTransferDetailsAndDisableWidget(hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, dialogHtml, { event: SDK_EVENTS.DIALOG_TEMPLATE, data: searchResponse.dialogs });
            dialogSuggestionElement?.append(dialogHtml);            
            rootServiceInstance.handleDialogClickEvents(dialogHtml, searchResponse?.dialogs, hostInstance);
        }

        if ((searchResponse?.faqs || [])?.length) {
            let faqHtml: any;
            let faqMoreLessActionHtml: any;
            faqHtml = getHTML(FAQSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, faqs: searchResponse.faqs, viewCount: 2 }, hostInstance);
            faqMoreLessActionHtml = getHTML(HandleViewMoreLessButtons, { hostInstance: hostInstance, faqs: searchResponse.faqs, moreClick: false, suggestionLength :  searchResponse.faqs?.length, showLessText : 'Show less FAQs', showMoreText : 'Show more FAQs' }, hostInstance);
            if (faqMoreLessActionHtml) {
                faqHtml?.append(faqMoreLessActionHtml);
            }
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, faqHtml, { event: SDK_EVENTS.FAQ_TEMPLATE, data: searchResponse.faqs });
            faqSuggestionElement?.append(faqHtml);
            if(faqHtml){
                rootServiceInstance.handleSeeMoreButtonsForFaq(faqSuggestionElement, ClassMapConstanst.DESC_TEXT_SUGGESTION, ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance);
            }
            let faqListHTML = faqHtml.querySelectorAll(classConstants.SUGGESTION_EACH);
            rootServiceInstance.renderEachFaqInSuggestionList(searchResponse, faqListHTML, hostInstance, true, props);
            //more and less article button click events handling
            if (faqMoreLessActionHtml) {
                rootServiceInstance.handleSuggestionMoreClickEvent(faqMoreLessActionHtml, faqSuggestionElement, faqListHTML, hostInstance);
                rootServiceInstance.handleSuggestionLessClickEvent(faqMoreLessActionHtml, faqSuggestionElement, faqListHTML, hostInstance);
            }

            rootServiceInstance.renderFeedbackForEachSuggestion(faqListHTML, searchResponse.faqs, FeebackConst.FAQS, hostInstance);
        }

        if (searchResponse?.snippets?.length) {
            let snippetHtml: any;
            snippetHtml = getHTML(SnippetSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, snippets: searchResponse.snippets, suggestionIndex : props.suggestionIndex }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, snippetHtml, { event: SDK_EVENTS.SNIPPET_TEMPLATE, data: searchResponse.snippets });
            snippetSuggestionElement?.append(snippetHtml);
            if(snippetHtml){
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(snippetSuggestionElement, ClassMapConstanst.DESC_TEXT_SNIPPET_EXTERNAL, ClassMapConstanst.EXTERNAL_SNIPPET_MORE_BTN_CONTAINER, hostInstance);
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(snippetSuggestionElement, ClassMapConstanst.DESC_TEXT_SNIPPET_INTERNAL, ClassMapConstanst.INTERNAL_SNIPPET_MORE_BTN_CONTAINER, hostInstance);
            }
            let snippetListHtml = snippetHtml.querySelectorAll(classConstants.SUGGESTION_EACH);
            rootServiceInstance.renderEachSnippetInSuggestionList(searchResponse, snippetListHtml, hostInstance);
            rootServiceInstance.renderFeedbackForEachSuggestion(snippetListHtml, searchResponse.snippets, FeebackConst.ANSWERS, hostInstance);

        }

        if ((searchResponse?.articles || [])?.length > 0) {
            let articleHtml: any;
            let articleMoreLessActionHtml: any;
            articleHtml = getHTML(ArticleSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, articles: searchResponse.articles, viewCount: 2 }, hostInstance);
            articleMoreLessActionHtml = getHTML(HandleViewMoreLessButtons, { hostInstance: hostInstance, articles: searchResponse.articles, moreClick: false, suggestionLength :  searchResponse.articles?.length, showLessText : 'Show less web pages', showMoreText : 'Show more web pages'}, hostInstance);
            if (articleMoreLessActionHtml) {
                articleHtml?.append(articleMoreLessActionHtml);
            }
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, articleHtml, { event: SDK_EVENTS.ARTICE_TEMPLATE, data: searchResponse.articles });
            articleSuggestionElement?.append(articleHtml);

            if(articleHtml){
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(articleSuggestionElement, ClassMapConstanst.DESC_TEXT_SUGGESTION, ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance);
            }
            
            // send, copy and link buttons of article click events handling.
            let articlesListHTML = articleHtml.querySelectorAll(classConstants.SUGGESTION_EACH);

            rootServiceInstance.renderEachArticleInSuggestionList(searchResponse, articlesListHTML, hostInstance);

            //more and less article button click events handling
            if (articleMoreLessActionHtml) {
                rootServiceInstance.handleSuggestionMoreClickEvent(articleMoreLessActionHtml, articleSuggestionElement, articlesListHTML, hostInstance);
                rootServiceInstance.handleSuggestionLessClickEvent(articleMoreLessActionHtml, articleSuggestionElement, articlesListHTML, hostInstance);
            }
            rootServiceInstance.renderFeedbackForEachSuggestion(articlesListHTML, searchResponse.articles, FeebackConst.ANSWERS, hostInstance);

        }

        if (searchResponse?.files?.length) {
            let fileHtml: any;
            let fileMoreLessActionHtml: any;
            fileHtml = getHTML(FileSuggestion, { searchResponse: searchResponse, hostInstance: hostInstance, files: searchResponse.files }, hostInstance);
            fileMoreLessActionHtml = getHTML(HandleViewMoreLessButtons, { hostInstance: hostInstance, files: searchResponse.files, moreClick: false, suggestionLength :  searchResponse.files?.length, showLessText : 'Show Less Files', showMoreText : 'Show More Files' }, hostInstance);
            if (fileMoreLessActionHtml) {
                fileHtml?.append(fileMoreLessActionHtml);
            }
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, fileHtml, { event: SDK_EVENTS.FILE_TEMPLATE, data: searchResponse.files });
            fileSuggestionElement?.append(fileHtml);

            if(fileHtml){
                rootServiceInstance.handleSeeMoreButtonsForSearchAssist(fileSuggestionElement, ClassMapConstanst.DESC_TEXT_SUGGESTION, ClassMapConstanst.MORE_BTN_CONTAINER, hostInstance);
            }
            // send, copy and link buttons of file click events handling.
            let filesListHtml = fileHtml.querySelectorAll(classConstants.SUGGESTION_EACH);

            rootServiceInstance.renderEachFileInSuggestionList(searchResponse, filesListHtml, hostInstance);

            
            //more and less file button click events handling
            if (fileMoreLessActionHtml) {
                rootServiceInstance.handleSuggestionMoreClickEvent(fileMoreLessActionHtml, fileSuggestionElement, filesListHtml, hostInstance);
                rootServiceInstance.handleSuggestionLessClickEvent(fileMoreLessActionHtml, fileSuggestionElement, filesListHtml, hostInstance);
            }
            rootServiceInstance.renderFeedbackForEachSuggestion(filesListHtml, searchResponse.files, FeebackConst.ANSWERS, hostInstance);
        }
        checkFaqAnswerNotRenderCountAndRequest();
    }

    const checkFaqAnswerNotRenderCountAndRequest = () => {
        const answerNotRenderedElements = searchResponse.faqs?.filter((faq: any, index : any) =>  {
            if (!faq.answer) {
                faq.index = index;
                return true;
            }
            return false;
        });
        if (answerNotRenderedElements?.length === 1) {
            getFaqAnswerAndToggle(answerNotRenderedElements[0], answerNotRenderedElements[0]?.index);
        }
    };

    const getFaqAnswerAndToggle = (faq: any, index : number) => {
        let faqId = idConstants.ASSIST_FAQ_SUGGESTION + props.suggestionIndex;
        rootServiceInstance.toggleArrows(index, faqId, hostInstance);
        faq.toggle = !faq.toggle;
        faq.seeMoreWrapper = false;
        rootServiceInstance.checkAnswerAndToggleForAssist(faq, index, hostInstance, props);
    };


    return (
        <Fragment>
            {(Object.keys(searchResponse)?.length > 0) && (
                <div className="assist-suggestions-list" id={`${idConstants.ASSIST_SUGGESTIONS}${responseUUId}`}>
                    <SuggestionPlaceholder hostInstance={hostInstance} searchResponse={searchResponse} suggestionIndex={props.suggestionIndex} isAssist ={true}/>
                </div>
            )}
        </Fragment>
    )
}
